import { createContext, useContext } from "react";

// Integration readiness for the comms surfaces (Call / Text / Messages / Fleet). The provider
// lives in App; consumers gate their actions on it and guide the operator to setup when not ready.
// Defaults are optimistic (true) so nothing is wrongly blocked before readiness loads — the server
// (send-sms / twilio-call return 409) is the real backstop.
export const CommsContext = createContext({
  textingReady: true,
  fleetReady: true,
  number: null,
  requireTexting: () => true, // returns true if ready; else fires the guide + returns false
  guideTexting: () => {},
  guideFleet: () => {},
});

export const useComms = () => useContext(CommsContext);
